export const demoGameStatus = {
    "isLegislativeActive": true,
    "isBillNoBillActive": true,
    "isBillBecomesLawActive": true,
    "isExecutiveActive": true,
    "isJudicialActive": true,
    "isConstitutionActive": true,
    "isQuizActive": true,
    "isFinalActive": true,
    "isRapidFireEconomicsActive": true,
    "isPursuitActive": true,
    "isRapidFireEnglishActive": true,
    "isCrossWordActive": true,
    "isRapidFireForeignLanguageActive": true,
    "isQuizForeignLanguageActive": false,
    "isRapidFireHistoryActive": true,
    "isHistoryBillNoBillActive": true,
    "isConnect4Active": true,
    "isMathahtzeeActive": true,
    "isRapidFireScienceActive": true,
    "isPeriodicTableActive": true,
    "isLooseLinkActive": true
};

export const demoProfileInfo = {
    "id": "DEMO_USER",
    "firstName": "Demo",
    "lastName": "User",
    "email": "demo@user.com",
    "phoneNumber": null,
    "ageRange": "20-30",
    "school": null,
    "profilePicUrl": "",
    "total": 0,
    "isFromClassLink": false
};

export const role = "user";

export const selectedSubjectDataValue = {
    "id": 1,
    "image": "https://openxcell-development-public.s3.ap-south-1.amazonaws.com/Civic_Master/game-images/Background/civics.png",
    "name": "civics",
    "navigateTo": "/civics",
    "backgroundImg": "https://openxcell-development-public.s3.ap-south-1.amazonaws.com/Civic_Master/game-images/Background/CivicsBackground.webp",
    "tinyImage": "https://openxcell-development-public.s3.ap-south-1.amazonaws.com/Civic_Master/game-images/Background/CivicsBackgroundSmall.webp"
};

export const demoSubjectAccessList = [
    {
        "subjectId": "demoSubjectId",
        "subject": "Science"
    },
    {
        "subjectId": "demoSubjectId",
        "subject": "Economics"
    },
    {
        "subjectId": "demoSubjectId",
        "subject": "Foreign Language"
    },
    {
        "subjectId": "demoSubjectId",
        "subject": "Math"
    },
    {
        "subjectId": "demoSubjectId",
        "subject": "English"
    },
    {
        "subjectId": "demoSubjectId",
        "subject": "Civics"
    },
    {
        "subjectId": "demoSubjectId",
        "subject": "History"
    }
];
